var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.24,
    height: 73.24,
    viewBox: "0 0 73.24 73.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.11,36.62a3.5,3.5,0,0,1-3.5,3.5H40.12V52.61a3.5,3.5,0,0,1-7,0V40.12H20.64a3.5,3.5,0,0,1,0-7H33.12V20.64a3.5,3.5,0,0,1,7,0V33.12H52.61A3.5,3.5,0,0,1,56.11,36.62Zm17.13,0A36.62,36.62,0,1,1,36.62,0,36.66,36.66,0,0,1,73.24,36.62Zm-7,0A29.62,29.62,0,1,0,36.62,66.24,29.66,29.66,0,0,0,66.24,36.62Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.51259613d8ad2063b4c9ce3dd64bcfa5.svg";
export { ForwardRef as ReactComponent };